'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$21() {
  this.b6k = null;
  this.b6l = false;
}
export { $c_Lpresto_LoginPageView$$anon$21 as $c_Lpresto_LoginPageView$$anon$21 };
$p = $c_Lpresto_LoginPageView$$anon$21.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$21;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$21() {
}
export { $h_Lpresto_LoginPageView$$anon$21 as $h_Lpresto_LoginPageView$$anon$21 };
$h_Lpresto_LoginPageView$$anon$21.prototype = $p;
$p.P = (function() {
  if ((!this.b6l)) {
    this.b6k = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T3($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.b6l = true;
  }
  return this.b6k;
});
var $d_Lpresto_LoginPageView$$anon$21 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$21, "presto.LoginPageView$$anon$21", ({
  Md: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_LoginPageView$$anon$21 as $d_Lpresto_LoginPageView$$anon$21 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$21.js.map
